"use client";

import { createApiClient } from "@donista/shared/api/client";
import { createQueryApi } from "@donista/shared/api/query";
import type { Middleware } from "openapi-fetch";
import { getFirebaseAuth } from "@/lib/firebase/client-app";
import { capturePosthogException } from "@/lib/safe-posthog";

const authMiddleware: Middleware = {
  async onRequest({ request }) {
    const token = await getFirebaseAuth().currentUser?.getIdToken();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
};

export const apiAuth = createApiClient({
  baseUrl: process.env.NEXT_PUBLIC_DONISTA_API_URL!,
  middleware: [authMiddleware],
  onError: (error) => capturePosthogException(error),
});

export const $api = createQueryApi(apiAuth);
